class Scene3DVista {

  constructor(viewportContainer) {
    if (!viewportContainer) {
      throw new Error('Viewport container for the scene is not specified.')
    }

    this.frame = document.createElement('iframe')
    this.frameContainer = document.createElement('div')
    this.viewportContainer = viewportContainer
    this.config = {}
  }

  getSceneConfig() {
    return this.config
  }

  setSceneConfig(config) {
    this.config = config
  }

  init() {

    let width = this.viewportContainer.clientWidth
    let height = this.viewportContainer.clientHeight

    let frameContainer = this.frameContainer
    frameContainer.style.position = 'relative'
    frameContainer.style.height = height + 'px'
    frameContainer.style['padding-top'] = '100%'

    let frame = this.frame
    frame.style.position = 'absolute'
    frame.style.top = 0
    frame.style.left = 0
    frame.style.width = width + 'px'
    frame.style.height = height + 'px'
    
    const frameAttributes = {
      name: this.config.title,
      width: width,
      height: height,
      frameborder: '0',
      allowfullscreen: 'true',
      allow: 'fullscreen; accelerometer; gyroscope; magnetometer; vr',
    }

    for (let key in frameAttributes) {
      frame.setAttribute(key, frameAttributes[key])
    }

    frame.onload = () => {
      this.viewportContainer.dispatchEvent( new CustomEvent('sceneIsLoaded') )
    }
    frame.src = this.config.path

    frameContainer.appendChild(frame)
    this.viewportContainer.appendChild(frameContainer)
  }

  destroy() {

  }

  updateSize() {
    let size = this.getViewportSize()

    this.frameContainer.style.width = size.width + 'px'
    this.frameContainer.style.height = size.height + 'px'

    this.frame.style.width = size.width + 'px'
    this.frame.style.height = size.height + 'px'
    this.frame.setAttribute('width', size.width)
    this.frame.setAttribute('height', size.height)
  }

  getViewportSize(fromViewportContainer = true) {
    return !fromViewportContainer
      ? { width: window.innerWidth, height: window.innerHeight }
      : { width: this.viewportContainer.clientWidth, height: this.viewportContainer.clientHeight }
  }

  toggleAutoRotateEnabled() {

  }
}

export default Scene3DVista
